import { AxiosResponse } from 'axios';

import { Axios } from '../AxiosApiServerWrapper';

export const TaskService = {
  GetPatientTasks: async (taskCode: string[]): Promise<AxiosResponse> => {
    const url = `tasks/patient-tasks`;
    return Axios.Request({ methodType: 'GET', url, params: { taskTypeCodes: taskCode } });
  },
  CreateTask: async (task: {
    code: string;
    userId: string;
    description: string;
    dueDate: string;
    team: string;
  }): Promise<AxiosResponse> => {
    const url = `tasks`;
    return Axios.Request({ methodType: 'POST', url, payload: task });
  },
};
